import { Component, OnInit } from "@angular/core";
import { CommonService } from "../common/common.service";
import { MainServiceService } from "./main-service.service";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.scss"]
})
export class MainComponent implements OnInit {
  userData:any;
  dateStart:any;
  endDate:any;
  TimerCount:number = 0;
  interval:any;

  constructor(private common:CommonService,private MainService:MainServiceService) {
  }
    ngOnInit() {
      this.userData = this.common.getUser();
      this.dateStart = new Date();
      localStorage.setItem('startTime',this.dateStart);
      this.interval = setInterval(() => {
        this.TimerCount= this.TimerCount +1;
          if(this.TimerCount == 300){
            this.updateTime();
          }
        
      }, 1000);
    }
    updateTime(){
      let startDate = localStorage.getItem('startTime')
      let startEpocTemp = new Date(startDate);
      let startEpoc=Math.floor(startEpocTemp.getTime() / 1000);
      this.endDate = new Date();
      let endEpocTemp = new Date(this.endDate);
      let endEpoc=Math.floor(endEpocTemp.getTime() / 1000);
      let diff =  endEpoc-startEpoc;
  
      let request = {
      "userId":this.userData['userId'],
      "startTime":startEpoc,
      "endTime":endEpoc,
      "type":"appTime",
      "useTime":diff
      }
      this.MainService.saveTime(request).subscribe(res => {
        if (res["message"] == "Success") {
          this.dateStart = new Date();
          localStorage.setItem('startTime',this.dateStart);
          this.TimerCount = 0;
        } else {
  
        }
      });
    }
}
